import { WidgetForm } from "./widget-form";

import { Popover } from "@headlessui/react";

import logo from "../assets/logo.svg";

interface WidgetProps {
  apiKey?: string;
  apiUrl?: string;
  orientation?: "left" | "right";
  showWatermark?: boolean;
  metadata?: {
    userId?: string;
    version?: string;
    custom?: Record<string, any>;
  };
}

export function Widget({
  apiKey,
  apiUrl,
  orientation = "right",
  showWatermark = true,
  metadata,
}: WidgetProps) {
  const positionClass =
    orientation === "left"
      ? "fixed bottom-4 left-4 md:bottom-8 md:left-8 flex flex-col items-start z-[99999]"
      : "fixed bottom-4 right-4 md:bottom-8 md:right-8 flex flex-col items-end z-[99999]";

  return (
    <div id="feedgetwidget">
      <Popover className={positionClass}>
        <Popover.Panel>
          <WidgetForm
            apiKey={apiKey}
            apiUrl={apiUrl}
            metadata={metadata}
            showWatermark={showWatermark}
          />
        </Popover.Panel>

        <Popover.Button
          title="Feedget"
          aria-label="Feedget"
          className="bg-brand-500 hover:bg-brand-300 cursor-pointer rounded-full px-3 h-12 text-white flex items-center group shadow-lg hover:shadow-brand-500/40 transition-all duration-500 ease-out active:scale-90 hover:scale-105 font-medium z-[99999] overflow-hidden relative"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

          <img
            src={logo}
            alt="Feedget Logo"
            className="w-6 h-6 transition-transform duration-300 group-hover:rotate-12"
          />

          <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 ease-in-out whitespace-nowrap">
            <span className="pl-2 text-sm font-semibold tracking-wide" />
            Feedget
          </span>
        </Popover.Button>
      </Popover>
    </div>
  );
}
